<template>
  <div class="scroll-main">
    <div class="photos" style="overflow: visible;">
    <a-upload-dragger
      name="file"
      list-type="picture-card"
      :multiple="true"
      :before-upload="beforeUpload"
      accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic"
      :file-list="fileList"
      :action="$api.domain + $api.addPhoto"
      @preview=" handlePreview"
      @change="handleuploadChange"

    >
    <div >
        <a-icon type="plus" />
        <div class="ant-upload-text">
          点击批量上传照片
        </div>
      </div>
    </a-upload-dragger>
    <!-- <div class="file-list">
      <div v-for="(item,index) in photoList" class="cell">
        <div class="img" :style='{backgroundImage:"url("+item.img_url+")"}'>

        </div>
      </div>
    </div> -->
    <a-modal :visible="previewVisible" width="800px" :footer="null" @cancel="previewVisible = false">
        <div style="padding:20px">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </div>
      </a-modal>

      <div class="fixbottom">
        <a-button @click.stop="handleUpload" type="primary" block>确认添加</a-button>
      </div>
  </div>
  </div>
  
</template>

<script>
import { mapState } from "vuex";
var wx = require('weixin-js-sdk');
import { checkFileFormat } from "@/utils/validate";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  data() {
    return {
      fileList: [],
      uploadState:false,
      id:'',
      photoList:[],
      previewVisible:false,
      previewImage:'',
      studentId:''
    };
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    this.id = this.$route.params.albumId;
    this.studentId = this.$route.params.studentId;
    // this.albumName = this.$route.query.name;
    // this.getPhoto()
  },
  watch: {
    userInfo(val) {
      if (val) {
        // this.getPhoto();
      }
    },
  },
  methods: {
    // 上传前校验文件格式
    beforeUpload(file) {
      if (!checkFileFormat(file)) {
        this.$message.error("请上传图片格式的文件");
        return false;
      }
      return true;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    //上传照片
    handleuploadChange({ fileList }) {
      this.fileList = fileList;
      console.log(this.fileList)
      // this.handleUpload();
    },
    getPhoto() {
      this.$message.loading({content:'加载中',key:"load"})
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.searchAlbumPhoto,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_id: this.id,
          type: '',
        },
      })
        .then((res) => {
          this.$message.success({content:'加载完成',key:"load"})
          if (res.data.status == 200 && res.data.data && JSON.stringify(res.data.data)  != '[]') {
            this.photoList = res.data.data;
          } else {
            this.photoList = []
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
    //上传代码
    handleUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = []
      var state = true;
      console.log(this.fileList)
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].status == 'done' && this.fileList[i].response && this.fileList[i].response.data) {
            img_url.push(this.fileList[i].response.data.url);
        } else if (this.fileList[i].status == 'uploading') {
          state = false;
          break;
        } else if (this.fileList[i].status == 'error' || this.fileList[i].response != 200) {
          errors.push(i+1)
        } 
      }
      console.log(img_url)
      if (!state) return false;
      console.log(errors)
      if (errors.length > 0) {
        this.$message.error(`第${errors.join(',')}文件上传失败`)
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.addStudentPhoto,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_id: this.id,
          img_url: img_url.join(","),
          student_id: this.studentId,
          
        },
        timeout:10000
      })
        .then((res) => {
          this.uploadState = false;
          // this.fileList = [];
          // this.getPhoto()
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 1000);
          wx.miniProgram.navigateBack()
          if (res.data.status == 200) {
            this.uploadModal = false;
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    }
  },
};
</script>

<style lang="scss">
.photos{
  width: 100%;
  padding: 0;
  margin: 0;
}
.scroll-main{
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 0;
  margin: 0;
  clear: both;
  overflow-x: hidden;
  padding-bottom: 52px;
}
.file-list{
  width: 100vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.file-list .cell{
  width: 25%;
  padding-top: 25%;
  position: relative;
  background: #ccc;
}
.file-list .cell .img{
  position: absolute;
  left: 1px;
  top: 1px;
  right: 1px;
  bottom: 1px;
  background-size: cover;
}
:v-deep(.ant-upload-list-picture-card-container .ant-upload-list-item-actions) {
  display: none!important;;
}
.ant-upload-list{
  width: 100vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  overflow: visible;
}
.ant-upload-list .ant-upload-list-picture-card-container{
    width: 25%;
    padding-top: 25%;
    margin: 0;
    padding: 1px;
}
.fixbottom {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height:50px;
  background: #fff;
  display: flex;
  padding:0 20px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  box-shadow: 0 -2px 2px 1px rgba($color: #000000, $alpha: .08);
}
</style>
